export default __webpack_public_path__ + "static/media/almond.043d2434.png";